import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  document.addEventListener("visibilitychange", onChange);
  return () => document.removeEventListener("visibilitychange", onChange);
};

/** 탭이 보이는지 — 숨은 탭에서는 사이트 애니메이션·자동 진행을 멈춘다. 서버 렌더에서는 보이는 것으로 본다. */
export function usePageVisible(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => !document.hidden,
    () => true
  );
}
